<template>
  <VisitorWrapper>
    <CContainer>
      <CRow
        v-if="!isAdultListLoading"
        class="justify-content-center mt-4 d-flex flex-column gap-4"
      >
        <!-- SERVER ERROR -->
        <VisitorErrorHandler
          v-if="serverError != null"
          :error="serverError"
          @done="serverError = null"
        />
        <!-- SERVER ERROR -->

        <!-- ADULT TABLE AND FILTER -->
        <VisitorAdultsTable />
        <!-- ADULT TABLE AND FILTER -->
      </CRow>
      <CRow
        v-else
        class="d-flex justify-content-center align-content-center mt-4 bg-white rounded-30 p-4 gap-2"
      >
        <CSpinner color="primary" />
      </CRow>
    </CContainer>
  </VisitorWrapper>
</template>
<script>
import VisitorErrorHandler from "@/v3components/VisitorErrorHandler.vue"
import VisitorAdultsTable from "@/v3components/Datatables/VisitorAdultsTable.vue"
import VisitorWrapper from "@/v3components/VisitorWrapper.vue"
import { onMounted, ref } from "vue"
import { useStore } from "vuex"

export default {
  name: "VisitorAdults",
  components: { VisitorAdultsTable, VisitorWrapper, VisitorErrorHandler },
  setup() {
    const store = useStore()
    const isAdultListLoading = ref(true)
    const serverError = ref(null)

    onMounted(async () => {
      try {
        isAdultListLoading.value = true
        await store.dispatch("visitorSettings/getAdults")
        await store.dispatch("schools/getActiveModules", {
          clearCacheEntry: true
        })
      } catch (error) {
        serverError.value = error
      } finally {
        isAdultListLoading.value = false
      }
    })

    return { isAdultListLoading, serverError }
  }
}
</script>
